import './landing.css';

import Header from './components/landing/Header';
import Hero from './components/landing/Hero';
import Problem from './components/landing/Problem';
import Solution from './components/landing/Solution';
import HowItWorks from './components/landing/HowItWorks';
import Testimonials from './components/landing/Testimonials';
import Pricing from './components/landing/Pricing';
import Guarantee from './components/landing/Guarantee';
import FAQ from './components/landing/FAQ';
import Footer from './components/landing/Footer';
import { MessageCircle } from 'lucide-react';
import analytics from '../../libs/analytics';

function Page({ user, setUser, loading }: any) {
  return (
    <div className="landing-page min-h-screen bg-background">
      <Header />
      <Hero />
      <Problem />
      <Solution />
      <HowItWorks />
      <Testimonials />
      <Pricing />
      <Guarantee />
      <FAQ />
      <Footer />
      
      {/* Floating WhatsApp Button */}
      <a 
        href="https://api.whatsapp.com/send/?phone=554391832935&text=Ol%C3%A1%21+Preciso+de+ajuda+com+o+ATARIC.&type=phone_number&app_absent=0" 
        target="_blank" 
        rel="noopener noreferrer"
        className="fixed bottom-6 right-6 z-50 flex items-center gap-2 bg-green-500 hover:bg-green-600 text-white px-4 py-3 rounded-full shadow-lg transition-all hover:scale-105"
        title="Dúvida sobre o método?"
        onClick={() => analytics.landingWhatsappClicked('floating_button')}
      >
        <MessageCircle className="w-6 h-6" />
        <span className="font-semibold hidden md:inline">Dúvida sobre o método?</span>
      </a>
    </div>
  );
}

export default Page;
